import { useEffect, useState } from "react";
import { Container, Card, TextField, Button, CssBaseline } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import TurnstileWrapped from "../components/TurnstyleWrapped";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay-ts";
import BeatLoader from "react-spinners/BeatLoader";
import { updatePassword } from "../services/registerService";
import TitleBox from "../components/TitleBox";
import { resetPasswordSchema, passwordResetInitialValues } from "../helpers/validationSchemas";

function ResetPage() {
  const [recaptchaCompleted, setRecaptchaCompleted] = useState<boolean>(false);
  const [emailToken, setEmailToken] = useState<string>("");
  const [validPassword, setValidPassword] = useState<boolean>(true);
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const { pathname } = window.location;
    const emailToken = pathname.replace("/credential/", "");
    setEmailToken(emailToken);
    debugger;
  }, [emailToken]);

  const handleSubmit = async (values: any, resetForm: Function) => {
    if (values.password === values.confirmPassword) {
      setLoading(true);
      await updatePassword(
        {
          pwd: values.password,
          verifypwd: values.confirmPassword
        },
        emailToken
      )
        .then(() => {
          setLoading(false);
          resetForm();
          Swal.fire({
            width: "30vw",
            icon: "success",
            title: "Password Changed!",
            /* eslint-disable-next-line */
            text: "Your password has successfully been changed. You will be redirected to the login page shortly.",
            timer: 5000
          });
        })
        .catch((err) => {
          setLoading(false);
          resetForm();

          Swal.fire({
            width: "30vw",
            icon: "error",
            title: "There was an issue changing your password.",
            text: err.response.data.message,
            confirmButtonText: "Request new password reset link"
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/password-reset";
            }
          });
        });
    } else {
      setValidPassword(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <LoadingOverlay active={isLoading} spinner={<BeatLoader color="#F4B43C" />}>
        <CssBaseline />
        <TitleBox title="Set Password" />

        <Card
          sx={{
            padding: 5,
            textAlign: "center",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
          }}
        >
          <Formik
            initialValues={passwordResetInitialValues}
            validationSchema={resetPasswordSchema}
            onSubmit={() => {}}
          >
            {({ isSubmitting, isValid, resetForm, values }) => (
              <Form>
                <Field
                  as={TextField}
                  variant="outlined"
                  margin="normal"
                  size="small"
                  required
                  fullWidth
                  id="password"
                  label="New Password"
                  name="password"
                  autoFocus
                  type="password"
                />
                <ErrorMessage
                  id="password-error"
                  name="password"
                  component="div"
                  className="error-message"
                />
                <Field
                  as={TextField}
                  variant="outlined"
                  margin="normal"
                  size="small"
                  required
                  fullWidth
                  id="confirmPassword"
                  label="Verify Password"
                  name="confirmPassword"
                  autoFocus
                  type="password"
                  className="input-field"
                />
                <ErrorMessage
                  id="password-confirm-error"
                  name="confirmPassword"
                  component="div"
                  className="error-message"
                />

                <TurnstileWrapped 
                  action="password-reset"
                  onChanged={(isValid)=>{
                    if(isValid){
                      setRecaptchaCompleted(true);
                    } else {
                      setRecaptchaCompleted(false);
                    }
                  }}
                />

                <Button
                  id="submit-button"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(values, resetForm);
                  }}
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: "#F5B43B",
                    color: "black",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                  disabled={isSubmitting || !recaptchaCompleted || !isValid || !validPassword}
                >
                  Submit
                </Button>
              </Form>
            )}
          </Formik>
        </Card>
      </LoadingOverlay>
    </Container>
  );
}

export default ResetPage;
